import React from 'react'
import { Dialog, Box, Typography, Button } from '@mui/material'
import Slide from '@mui/material/Slide';
import HelpIcon from '@mui/icons-material/Help';
import { useTranslation } from 'react-i18next';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const HelpDialog = ({ open, setOpenDialog }) => {
  const {t} = useTranslation()

  return <Dialog
    open={open}
    onClose={() => setOpenDialog(false)}
    TransitionComponent={Transition}
  >
    <Box>
      <Box
        p={4}
      >
        <HelpIcon color='secondary' sx={{ fontSize: '40px' }} />
        <Typography
          variant='h6'
          fontWeight='bold'
          sx={{ mt: 2, mb: 2, lineHeight: '1.4' }}
        >
          {t('wat_lijkt')}
        </Typography>
        <Typography variant='subtitle2'>
          {t('kies_alle_activiteiten')}
        </Typography>
        <Box
          display='flex'
          justifyContent='flex-end'
        >
          <Button
            onClick={() => setOpenDialog(false)}
          >
            {t('begrepen')}
          </Button>
        </Box>
      </Box>
    </Box>
  </Dialog>
}

export default HelpDialog
